import { FC, ReactElement, SyntheticEvent } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Social } from './partials/social'
import InputField from './partials/input-field'

export interface ForgotPasswordFormValues {
  email: string
}

interface Props {
  error: string
  isLanding: boolean
  isLoading: boolean
  handleSubmit: (values: ForgotPasswordFormValues) => void
  handleLoginLink: (e: SyntheticEvent) => void
  handleSignupLink: (e: SyntheticEvent) => void
}


export const ForgotPasswordForm: FC<Props> = ({
  error,
  isLanding = true,
  isLoading = false,
  handleSubmit,
  handleLoginLink,
  handleSignupLink,
}): ReactElement => {
  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string().required(),
  })

  const formik = useFormik<ForgotPasswordFormValues>({
    initialValues: {
      email: '',
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: async (values) => {
      handleSubmit(values)
    },
  })

  return (
    <>
      {error && (
        <div className="hbMessage">
          <div className="wrapperHb">
            <span>!</span>
            <p>{error}</p>
          </div>
        </div>
      )}
      <div className={`form ${isLanding ? 'iframe' : ''}`}>
        <div className="wrapper">
          <div className="form-logo">
            <span>
              <img
                src="/account/img/header/logo-big.svg"
                width="231"
                height="32"
                alt=""
              />
            </span>
          </div>
          <p>
            New to Practithink?{' '}
            <a href="#" onClick={handleSignupLink}>
              Create an account
            </a>
          </p>
          <h2 className="form-title">Forgot password</h2>

          <form autoComplete="off" onSubmit={formik.handleSubmit}>
            <InputField formik={formik} name="email">
              <label htmlFor="m-1">Email, User name or Account #</label>
              <input
                id="m-1"
                type="text"
                name="email"
                placeholder="Example: email@domain.com"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
            </InputField>

            {isLoading ? (
              <button type="button" disabled className="primary-btn">
                Submitting
              </button>
            ) : (
              <button type="submit" className="primary-btn">Send instruction</button>
            )}
            <a href="#" onClick={handleLoginLink}>
              Sign in?
            </a>
            <br /><br />
            <Social />
          </form>
        </div>
      </div>
    </>
  )
}
